// Short message shown above the avatar button when the guide can't start
// (microphone blocked / missing, connection failed). Click or wait to dismiss.
const DEFAULT_DURATION_MS = 8000;

export default function showAvatarNotice(text, { duration = DEFAULT_DURATION_MS } = {}) {
  document.querySelectorAll('.avatar-notice').forEach(el => el.remove());
  const el = document.createElement('div');
  el.className = 'avatar-notice';
  el.setAttribute('role', 'alert');
  el.textContent = text;
  const remove = () => {
    clearTimeout(timer);
    el.remove();
  };
  el.addEventListener('click', remove);
  const timer = setTimeout(remove, duration);
  document.body.appendChild(el);
  return { destroy: remove };
}
